import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";

export function InfoBalloon({
  children,
  title,
  fontSize,
  ...rest
}: {
  title?: ReactNode;
} & Omit<BoxProps, "title">) {
  return (
    <Box
      w="100%"
      bg="gray.100"
      border={"1px solid var(--chakra-colors-gray-200)"}
      p="4px"
      borderRadius="10px"
      {...rest}
    >
      <Box fontSize={fontSize || "12"} whiteSpace="pre-wrap">
        {title ? (
          <>
            <Box fontWeight="bold">{title}</Box>
            <br />
          </>
        ) : null}

        {children}
      </Box>
    </Box>
  );
}
